<template>
  <div class="page_crud--create">
    <div class="inner-wrap" v-if="!load">
      <el-form ref="form" class="form" :model="input">
        <div class="row" v-for="(row,index) in rows" :key="index">
          <div class="field" v-for="(field,index) in row" :key="index">

            <el-form-item class="input-field"  v-if="field.hidden == undefined || !field.hidden.includes('create')" :class="typeof field.type == 'string' ? field.type : 'text'" :prop="field.key" v-model="input[field.key]">
              <!-- <el-checkbox v-model="input[field.key]" v-if="field.type == 'boolean'" :label="$t(`field.${key}.${field.key}`)" true-label="1" false-label="0"/> -->
              <div class="control-group" v-if="field.type == 'boolean'">
                <div class="checkbox-group" v-if="field.type == 'boolean'">
                  <input type="checkbox" v-model="input[field.key]" true-value="1" false-value="0" :id="`${field.key}--${index}`">
                  <label class="label" :for="`${field.key}--${index}`">{{ tran(key, field.key) }}</label>
                </div>
                <div class="error-message" v-if="error_fields.hasOwnProperty(field.key)">{{ getErrMsg(field.key) }}</div>
              </div>

                <div v-else-if="field.type == 'image'" class="control-group">
                    <img :src="`/${$conf.NAMESPACE}${field.imageSrc}`">
                </div>

              <div class="control-group" v-else-if="field.type == 'select'">
                <div class="label">{{ tran(key, field.key) }}</div>
                <!-- <el-select v-model="input[field.key]" placeholder="Select" :remote="true" :key="options.hasOwnProperty(currentSetting.options[field.key].key) ? options[currentSetting.options[field.key].key].length : 0">
                  <el-option
                    v-for="item in options[currentSetting.options[field.key].key]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select> -->
<!--                <select v-model="input[field.key]" @change="forceUpdate" :disabled="field.hasOwnProperty('disabled')">-->
                  <select v-model="input[field.key]"  @change="forceUpdate">
                  <option
                    v-if="currentSetting.options[field.key].values"
                    v-for="opt in currentSetting.options[field.key].values"
                    :value="opt.value"
                    :key="opt.key"
                  >{{ $t(opt.key) }}</option>
                  <option :value="item.value" v-for="item in options[currentSetting.options[field.key].key]" :key="item.value">{{ item.label }}</option>
                </select>
                <div class="error-message" v-if="error_fields.hasOwnProperty(field.key)">{{ getErrMsg(field.key) }}</div>
              </div>
              <Component :is="field.component" v-else-if="field.type == 'component'" :data="input" :key="componentsKey[field.key]"/>
              <div class="control-group" :class="[{ 'error--field': errors.includes(field.key) }]" v-else-if="field.type == 'componentColumn'">
                <div class="label">{{ tran(key, field.key) }}</div>
                <Component :is="field.component" :options="options" :action="'Create'" :k="key" v-model="input[field.key]" :field="field" :data="input" :ref="`componentColumn-${field.key}`" :key="componentsKey[field.key]"/>
                <div class="error-message" v-if="error_fields.hasOwnProperty(field.key)">{{ getErrMsg(field.key) }}</div>
              </div>


              <!-- <div v-else-if="field.type == 'select'">{{  }}</div> -->
              <div class="label-group" :class="[{ 'error--field': errors.includes(field.key) }]" v-else>
                <label class="label" :for="field.key">{{ tran(key, field.key) }}</label>
                <textarea rows="10" v-if="field.row && field.row > 1" v-model="input[field.key]"></textarea>
                <input v-model="input[field.key]" :type="field.password ? 'password' : field.type == 'date' ? 'date' : field.type == 'time' ?'time' : 'text'" @input="errorClear(field.key)" v-else @change="forceUpdateInputText(field)">
                <div class="error-message" v-if="error_fields.hasOwnProperty(field.key)">{{ getErrMsg(field.key) }}</div>
                <!-- <el-input
                  :rows="field.row ? field.row : 1"
                  :type="field.row && field.row > 1 ? 'textarea' : ''"
                  :label="field.key"
                  :name="field.key"
                  v-model="input[field.key]"
                  :show-password="field.password"
                /> -->
              </div>
            </el-form-item>

          </div>
        </div>
      </el-form>
      <div class="action-btn">
        <el-button @click="go(`${key}`)">{{ $t("button.back") }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t("button.confirm") }}</el-button>
      </div>
    </div>
  </div>  
</template>

<script>
import { mapState } from "vuex";

export default {
  async created() {
    this.key = this.$route.params.key;
    Object.assign(this.currentSetting, this.$setting.crud[this.key]);
    // if(!this.permissions.includes(`CREATE_${this.currentSetting.key}`.toUpperCase())) {
    //   this.$router.push({ name: "error", params: { code: 403 } });
    // }
    this.currentSetting.fields = [...this.currentSetting.fields.filter(f=>{
      if(f.type == "action-btn") return false;
      if(f?.hidden?.includes("write")) return false;
      if(f?.hidden?.includes("create")) return false;
      // privilege check
      if(f?.privilege) {
        console.log("privilege", f.privilege);
        let auth = true;
        f.privilege.map(p=>{
          if(!this.permissions.includes(p)) {
            console.log("p: ", p);
            auth = false;
          }
        });
        console.log("auth: ",auth);
        return auth;
      }
      //
      if(typeof f.hidden == "undefined") return true;
      return true;
    })];
    if(this.currentSetting.structure) {
      this.rows = [];
      this.currentSetting.structure.map((row,i)=>{
        this.rows[i] = [];
          row.map((field,j)=>{
          let current = this.currentSetting.fields.find(f=>f.key==field);
          if(current) {
            this.rows[i].push(current);
          }
        })
      });
    }else {
      this.rows = this.currentSetting.fields.map(field=>{
        return [field];
      });
    }
    console.log("this.rows", this.rows);
    if(this.currentSetting.hasOwnProperty("default") && Object.keys(this.currentSetting.default)) {
      Object.keys(this.currentSetting.default).map(key=>{
        this.input[key] = `${this.currentSetting.default[key]}`;
      });
    }
    console.log("this.input", this.input);
  },
  async beforeMount() {
    
    this.load = true;
    
    //option
    if(this.currentSetting.options) {
      await this.$axios.get(`options?opts=${Object.keys(this.currentSetting.options).map(key=>this.currentSetting.options[key].key).join("&opts=")}`, {
        params: {
          // opts: Object.keys(this.currentSetting.options).map(key=>this.currentSetting.options[key].key).join("&opts=")
        }
      }).then(res=>{
        let options = res.data.response.options;
        console.log("keys: ",Object.keys(options));

        Object.keys(this.currentSetting.options).filter(opt=>options.hasOwnProperty(this.currentSetting.options[opt].key)).map(opt=>{
          console.log("opt: ",opt);
          let key = this.currentSetting.options[opt].key;
          this.options[key] = options[key].map((value,index)=>{
            console.log("index: ",index);
            console.log("value: ",value);
            let field = this.currentSetting.fields.find(f=>f.key==opt);
            if(index == 0 && field && !field.notfill) {
              if(this.input[opt] == undefined){
                this.input[opt] = value[this.currentSetting.options[opt].value];
              }
            }
            return {
              label: typeof value == "object" ? value[this.currentSetting.options[opt].label] : value,
              value: typeof value == "object" ? value[this.currentSetting.options[opt].value] : value,
            }
          });
        });
        return true;
      }).catch(err=>{ return false; });
    }
    // prefill default value
    this.currentSetting.fields.map(field => {
      if(field?.type == 'component'||field?.type == 'componentColumn'){
        this.componentsKey[field.key]=1;
      }
    })

    this.load = false;
    //
    // this.currentSetting.fields.map(field=>{
    //   this.input[field] = "";
    // });
  },
  methods: {
    defineRule(rules) {
      let rule = {};
      if(Array.isArray(rules) && rules.includes("required")) {
        rule = {
          required: true
        };
      }
      return rule;
    },
    forceUpdate(){
      console.log(this.componentsKey);
      for(var i in this.componentsKey){
        this.componentsKey[i]++;
      }
      this.$forceUpdate();
    },
    forceUpdateInputText(field){
      if(field.forceUpdate){
          console.log(this.componentsKey);
          for(var i in this.componentsKey){
          this.componentsKey[i]++;
          }
          this.$forceUpdate();
      }
    },
    updateValue(field, value) {
      console.log("field: ",field);
      console.log("value: ",value);
      this.input[field] = value;
      this.refresh = new Date().getTime();
    },
    getErrMsg(field) {
      let label = this.tran(this.key, field);
      let arr = this.error_fields[field].split('-');
      let params = [];
      let msg = "";
      if(arr.length > 1){
          params=arr.filter((r,i) => i > 0);
      }
      msg = this.$te(`input_error.${arr[0]}`)
          ? this.$t(`input_error.${arr[0]}`,params)
          : this.error_fields[field];
      
      return `${label} ${msg}`;
    },
    async confirm() {
      if(this.$refs.form.validate()) {
        console.log("ok: ", this.input);
        let loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // let object = this.currentSetting.fields.filter(f=>f.hasOwnProperty("field")).map(f=>{
        //   this.input[f.key] = {
        //     id: this.input[f.key]
        //   }
        // });
          let redirect = false;
          let createdId = 0;

        let valid = await this.$axios.post(`/${this.currentSetting?.api?.create ? this.currentSetting?.api?.create : this.key}`, {
          ...this.input,
        }).then(res=>{
          if (res?.data?.status=='error'){
            this.$message({
              message: this.$t('error.'+res?.data?.errorCode),
              type: 'error'
            });
            return false;
          }
          console.log('res.data');
          console.log(res.data);
          if (res.data.includes(":")){
              redirect = true;
              var str = res.data.split(":");
                createdId = str[1];
                console.log("id created:")
                console.log(createdId);
          }
          return true;
        }).catch(err=>{
          console.log(err?.response?.data);
          if(err?.response?.data?.errors) {
            this.errors = err.response.data.errors;
          }
          if(err?.response?.data?.fields) {
            this.error_fields = err.response.data.fields;
          }
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
          return false;
        });
        loading.close();

        // only run if request success
        if(valid) {
            if (redirect){
                this.$router.push({ name: "EditView", params: { key: this.key, id: createdId } });
            }else{
                this.$router.push({ name: "List", params: { key: this.key } });
            }
        }
        
      }else {
        console.warn("wrong");
      }
    },
    errorClear(field) {
      console.log(field);
      this.errors = this.errors.filter(e=>e!=field);
      delete this.error_fields[field];
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.user.user_info.permissions
    }),
  },
  data() {
    return {
      load: false,
      key: "",
      currentSetting: {},
      options: {},
      refresh: 0,
      rows: [],

      input: {},
      errors: [],
      componentsKey:{},
      error_fields: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.page_crud--create{
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  .inner-wrap{
    // height: 100%;
    width: 95%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    padding: 20px 0;
    .form{
      flex-grow: 1;
      .row{
        display: flex;
        width: 100%;
          max-width: 100%;
        .field{
          flex: 1;
          // width: 100%;
          max-width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          & > :first-child{
            margin-right: 5px;
          }
        }
      }
      .checkbox-group{
        display: flex;
        align-items: center;
      }
      .label-group,
      .control-group{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .label{
          // width: 150px;
          // min-width: 150px;
        }
        input:not([type="checkbox"]){
          height: 30px;
          // width: 100%;
        }
        textarea{
          width: 100%;
        }
        .error-message{
          font-size: small;
          color: red;
          line-height: 1.5em;
        }
      }
      .el-form-item{
        margin-bottom: 10px;
        .el-select{
          width: 100%;
        }
        select{
          height: 40px;
          line-height: 40px;
          width: 100%;
        }
      }
      .field{
        &:not(:last-child){
          // margin-bottom: 10px;
        }
      }
      .error--field{
        .label{
          color: red;
        }
        input{
          border: 1.5px solid red;
          &:focus{
            outline: red auto 1px;
            border: 1.5px solid red!important;
          }
        }
      }
    }
    .action-btn{
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
    }
  }
}
</style>